import type { IconData } from '@stacksjs/iconify-core'

export const contentCut: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 14.182C16 15 15 16 14 16c-1.5 0-2.45-.5-3.452-1.366L6.74 11.171A3.5 3.5 0 1 1 1.051 10l2.2-2l-2.2-2a3.5 3.5 0 1 1 5.388-.598zM3.5 11.25a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5M4.75 3.5a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"m16 1.818l-5.624 5.164l-2.988-2.744l3.16-2.872C11.55.5 12.5 0 14 0c1 0 2 1 2 1.818\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentCut
